angular.module('pe4h').service('fbqService', function() {
    function fbq(param1, param2, param3) {
        if (document.fbq) {
            document.fbq(param1, param2, param3)
        }
    }
    return {
        'fbq': fbq
    }
})